import { useRef } from 'react';

import useNavigateWithTransition from '@/hooks/useNavigateWithTransition';
import useTranslations from '@/i18n/useTranslations';
import ArtlistImage from '@/shared-components/cards/components/ArtlistImage';
import PlayIconRounded from '@/shared-components/icons/components/actions/PlayIconRounded';
import Text from '@/shared-components/text/components/Text';

import './styles/ArtlistCard.css';

export default function ArtlistCard({ data, style={}, infiniteScrollObserver }) {
  const navigateWithTransition = useNavigateWithTransition();
  const t = useTranslations('common.profile.pages.artlist');
  const imageWrapperRef = useRef(null);

  const title = data.artlist_title || "Artlist";
  const creatorName =
    data.artlist_creator?.user_username
    || data.artlist_creator?.user_name
    || "User";
  const totalArtworks =
    typeof data.artlist_artworks_total === "number"
      ? data.artlist_artworks_total
      : data.artlist_artworks
        ? data.artlist_artworks.length
        : "a few";
  const coverImageId = data.artlist_image?.image_id;
  const altArtlistImage = `Artlist Cover. ${title} ${t('labels.by')} ${creatorName}. ${creatorName} contains ${totalArtworks} artworks.`;
  function navigateToArtlist(openTimeSelector = false) {
    if (imageWrapperRef.current) {
      imageWrapperRef.current.style.viewTransitionName = `artlist_${data._id}_animation`;
    }

    navigateWithTransition(`/artlist/${data._id}`, {
      state: {
        from: true,
        ...(openTimeSelector && { openTimeSelector: true }),
      },
    });
  }

  return (
    <div
      className="artlist-card__container"
      style={style}
      ref={infiniteScrollObserver}
      onClick={() => navigateToArtlist()}
    >
      <div className="artlist-card__media" ref={imageWrapperRef}>
        <ArtlistImage className="artlist-card__artlist-image" alt={altArtlistImage} image={coverImageId} />
      </div>

      <div className="artlist-card__info-container artlist-card__info-container--overlay">
        <div className="artlist-card__info-text">
          <Text className="artlist-card__artlist-name" paragraph>
            {title}
          </Text>

          <Text className="artlist-card__artlist-by" paragraph extraSmall>
            {t('labels.by')} <span>{creatorName}</span>
          </Text>
        </div>

        <button
          aria-label={t('time_selector.actions.play_artlist')}
          className="artlist-card__play"
          onClick={(event) => {
            event.stopPropagation();
            navigateToArtlist(true);
          }}
          type="button"
        >
          <PlayIconRounded className="artlist-card__play-icon" />
        </button>
      </div>
    </div>
  );
}
